import { render } from "./confirmation-approval-update-rates.vue?vue&type=template&id=40c311ca&ts=true"
import script from "./confirmation-approval-update-rates.vue?vue&type=script&lang=ts"
export * from "./confirmation-approval-update-rates.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__